import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';

import { SharedModule } from '../../shared/shared.module';
import { ExComponent } from './ex.component';
import { CategoryFilterModule } from '../../shared/pipes/category-filter/category-filter.module';
import { VideoPlayerModule } from 'app/theme/components/video-player/video-player.module';

@NgModule({
  imports: [CommonModule, SharedModule, ReactiveFormsModule, CategoryFilterModule, VideoPlayerModule],
  declarations: [ExComponent],
  exports: [ExComponent],
})
export class ExModule {}



// WEBPACK FOOTER //
// /codebuild/output/src3658806670/src/client/web-client/src/app/pages/exercises/ex.module.ts